import styled, { css } from 'styled-components';
import { media, layout, styledUtils } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import { Truncated } from '../../../../components/truncated';

const ITEM_WIDTH = 100;
const ITEM_MARGIN = 10;

export const Wrapper = styled.section`
  padding: 0 ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.xSmall};
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
`;

export const List = styled.ul.attrs({ 'data-test': 'NavigationList' })`
  display: inline-flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 -5px;
  flex-basis: ${8 * (ITEM_WIDTH + ITEM_MARGIN)}px;
`;

export type ListItemProps = {
  selected?: boolean;
  visible?: boolean;
};

const listItemStyles = css<ListItemProps>`
  width: ${ITEM_WIDTH}px;
  min-width: ${ITEM_WIDTH}px;
  height: 140px;
  min-height: 140px;
  display: ${p => (p.visible === true ? 'block' : 'none')};
  margin: 0 ${ITEM_MARGIN * 0.5}px ${ITEM_MARGIN}px;
`;

export const ListItem = styled.li<ListItemProps>`
  ${listItemStyles}
`;

export const ListItemDiv = styled.div<ListItemProps>`
  ${listItemStyles}
`;

export const ListItemLink = styled(Clickable)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  &::after {
    ${styledUtils.overlay()}
    display: block;
  }
  &:hover::after {
    display: none;
  }
`;

export const ListItemText = styled.div`
  margin: 0 10px;
  font-size: ${layout.measurements.fontSizeSmall};
  ${media.smallOnly`
    font-size: ${layout.measurements.fontSizeSmall};
  `}
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const numberWithDefault = (value: number | undefined, defaultValue: number) =>
  value !== undefined ? value : defaultValue;

type LimitedTextFieldProps = {
  lines?: number;
  lineHeight?: number;
};

export const LimitedTextField = styled(Truncated).attrs<LimitedTextFieldProps>(
  ({ lines }) => ({ maxLines: numberWithDefault(lines, 2) })
)<LimitedTextFieldProps>`
  line-height: ${({ lineHeight }) => numberWithDefault(lineHeight, 1.2)}rem;
  max-height: ${({ lines, lineHeight }) =>
    numberWithDefault(lines, 2) * numberWithDefault(lineHeight, 1.2)}rem;
  word-break: break-word;
  white-space: normal;
  font-weight: 600;
`;

export const ListItemImage = styled.div`
  width: 80px;
  height: 80px;
  margin: 10px 10px 0;
`;

export const ListAction = styled.div`
  ${listItemStyles}
  display: block;
  margin: 0px 0 10px 10px;
`;

export const ListActionButton = styled(ListItemLink)`
  padding: 10px;
`;
